<template>
  <layer-page typeTitle="水样对比"></layer-page>
</template>

<script>
import layerPage from '../components/layerPage.vue'
export default {
  components: {
    layerPage
  }
}
</script>
